import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../client";
import BlockContent from "@sanity/block-content-to-react";
import { useMediaQuery } from "@uidotdev/usehooks";
import NavBar from "./NavBar";
import NavBarMobile from "./NavBarMobile";
import Footer from "./Footer";
import Form from "./Form";

export default function SingleEvent() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  const allDevices = useMediaQuery("only screen and (min-width : 769px)");

  const [event, setEvent] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "event" && slug.current == "${slug}"][0]{
        title,
        autor,
        mainImage{
          asset->{
            _id,
            url
          }
        },
        description
      }`,
      )
      .then((data) => setEvent(data))
      .catch(console.error);
  }, [slug]);

  if (!event) return <div>Loading...</div>;

  return (
    <>
      {allDevices && <NavBar />}
      {isSmallDevice && <NavBarMobile />}

      <main className="bg-white-100 min-h-screen py-12 px-4 md:p-12">
        <article className="container mx-auto max-w-screen-xl">
          <h1 className="text-3xl mb-6">{event.title}</h1>

          <img
            src={event.mainImage.asset.url}
            alt={event.title}
            className="w-full mb-6"
          />

          <div className="mb-6">
            <BlockContent
              blocks={event.description}
              projectId="krjmu28b"
              dataset="production"
            />
          </div>

          <p className="text-gray-500">{event.autor}</p>
        </article>
      </main>

      <Form />
      <Footer />
    </>
  );
}
